import { BillingFormFields } from "../../../NormasTeachingCheckout/BillingFormSection.tsx";
import { BusinessType } from "../../../MoneyTransfer/BusinessType.tsx";
import type { OrderInvoiceInfoDTO } from "../../../Stripe/StripeOrderDTO.ts";
import type { RequestedOrderInvoiceInfoDTO } from "./InstallmentsSettlementDTO.ts";
import type { BonificoOrderDTO } from "../../../ProductService/BonificoOrder/BonificoOrderDTO.ts";
import { toBonificoBillingFormFields } from "../../../ProductService/BonificoOrder/bonificoBilling.ts";
import { toBonificoCustomerTaxCode } from "../../../ProductService/BonificoOrder/toBonificoBusinessInformation.ts";
import {
  isForeignBillingCountry,
  ItalianBillingCountry,
} from "../../../MoneyTransfer/billingCountries.ts";

export function toSettlementBillingDefaultsOfDraft(
  draft: BonificoOrderDTO,
): BillingFormFields {
  return { ...toBonificoBillingFormFields(draft), invoiceRequired: true };
}

export function toSettlementBillingDefaults(
  invoiceInfo: OrderInvoiceInfoDTO,
): BillingFormFields {
  if (!invoiceInfo.requested)
    return {
      invoiceRequired: true,
      businessType: BusinessType.Person,
      address: {
        street: "",
        cap: "",
        city: "",
        province: "",
        country: ItalianBillingCountry.Italy,
      },
    };
  return {
    invoiceRequired: true,
    businessType: invoiceInfo.businessType,
    businessName:
      "businessName" in invoiceInfo ? invoiceInfo.businessName : undefined,
    vat: "vat" in invoiceInfo ? invoiceInfo.vat : undefined,
    taxCode: invoiceInfo.taxCode,
    address: {
      ...invoiceInfo.address,
      country: invoiceInfo.address.country || ItalianBillingCountry.Italy,
    },
    pec: "pec" in invoiceInfo ? invoiceInfo.pec : undefined,
    sdiCode: "sdiCode" in invoiceInfo ? invoiceInfo.sdiCode : undefined,
  };
}

export function toRequestedInvoiceInfo(
  billing: BillingFormFields,
): RequestedOrderInvoiceInfoDTO {
  const country = billing.address?.country || ItalianBillingCountry.Italy;
  const isForeignCustomer = isForeignBillingCountry(country);
  const taxCode = toBonificoCustomerTaxCode(billing) ?? "";
  const address = {
    street: billing.address?.street ?? "",
    cap: billing.address?.cap ?? "",
    city: billing.address?.city ?? "",
    province: billing.address?.province ?? "",
    country,
  };
  const pec = isForeignCustomer ? undefined : billing.pec || undefined;
  const sdiCode = isForeignCustomer ? undefined : billing.sdiCode || undefined;

  switch (billing.businessType) {
    case BusinessType.Company:
      return {
        requested: true,
        businessType: BusinessType.Company,
        businessName: billing.businessName ?? "",
        taxCode,
        vat: billing.vat ?? "",
        pec,
        sdiCode,
        address,
      };
    case BusinessType.IndividualCompany:
      return {
        requested: true,
        businessType: BusinessType.IndividualCompany,
        taxCode,
        vat: billing.vat ?? "",
        pec,
        sdiCode,
        address,
      };
    default:
      return {
        requested: true,
        businessType: BusinessType.Person,
        taxCode,
        ...(isForeignCustomer && { vat: billing.vat ?? "" }),
        address,
      };
  }
}
